import type { InputHTMLAttributes } from 'react';

/** YYYY-MM-DD → DD/MM/YYYY. Local copy to keep this component dependency-free. */
function frLabel(iso: string): string {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  if (!y || !m || !d) return '';
  return `${d}/${m}/${y}`;
}

type NativeDateProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'>;

interface FrDateInputProps extends NativeDateProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * A `<input type="date">` that always displays dd/mm/yyyy, regardless of the
 * OS/browser locale (Chromium's date input format follows the OS regional
 * settings, not the page `lang`, so an English-Windows host renders mm/dd/yyyy
 * otherwise). Keeps the real native input — calendar popup, keyboard entry,
 * mobile UX — but hides its locale-formatted text and overlays a fixed
 * dd/mm/yyyy label on top.
 */
export function FrDateInput({ value, onChange, className, ...rest }: FrDateInputProps) {
  return (
    <span className="fr-date" data-empty={value ? undefined : ''}>
      <input
        type="date"
        className={'fr-date-native ' + (className ?? '')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...rest}
      />
      <span className="fr-date-label" aria-hidden="true">
        {frLabel(value)}
      </span>
    </span>
  );
}
